<template>
  <div class="inquiry_list">
    <el-form :inline="true" :model="dataForm">
      <el-form-item label="单据编号：">
        <el-input
          v-model.trim="dataForm.userAfterSalesCode"
          placeholder="单据编号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="订单编号：">
        <el-input
          v-model.trim="dataForm.orderCode"
          placeholder="订单编号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="商品编码：">
        <el-input
          v-model.trim="dataForm.goodsCode"
          placeholder="商品编码"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="商品名称：">
        <el-input
          v-model.trim="dataForm.goodsName"
          placeholder="商品名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select
          v-model="dataForm.userAfterSalesStatusList"
          multiple
          collapse-tags
          clearable
          placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button class="butt" type="primary" @click="getDataList(1)"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      key="inquiryTable"
      v-loading="dataLoading"
      border
    >
      <div class="no_show_message" slot="empty">
        <img src="@/assets/img/good/noGood.png" alt="暂无数据" />
        <div>暂无数据</div>
      </div>
      <el-table-column
        type="index"
        header-align="center"
        align="center"
        width="50"
      ></el-table-column>
      <el-table-column
        prop="userAfterSalesCode"
        header-align="center"
        align="center"
        label="售后单号"
      ></el-table-column>
      <el-table-column
        prop="orderCode"
        header-align="center"
        align="center"
        label="订单编号"
      ></el-table-column>
      <el-table-column
        prop="goodsCode"
        header-align="center"
        align="center"
        label="商品编号"
      ></el-table-column>
      <el-table-column
        prop="goodsName"
        header-align="center"
        align="center"
        label="商品名称"
      ></el-table-column>
      <el-table-column
        prop="afterSalesNum"
        header-align="center"
        align="center"
        label="申请数量"
      ></el-table-column>
      <el-table-column
        prop="userAfterSalesType"
        header-align="center"
        align="center"
        label="申请类型"
      >
        <template slot-scope="scope">
          {{ $getDictLabel('USER_AFTER_SALES_TYPE', scope.row.userAfterSalesType) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        label="制单时间"
      ></el-table-column>
      <el-table-column
        prop="status"
        header-align="center"
        align="center"
        label="状态"
        width="100px"
      >
        <template slot-scope="scope">
          {{ $getDictLabel('USER_AFTER_SALES_STATUS', scope.row.userAfterSalesStatus) }}
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="操作"
        width="100"
      >
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="detailHandle(scope.row)">
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="dataForm.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="dataForm.limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="getDataList"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: 'afterSalesList', // 询价列表页
  data () {
    return {
      dataLoading: false,
      options: [ // 1待受理 2已驳回 3处理中 4已取消 5已完成
        {
          value: '1',
          label: '待受理'
        },
        {
          value: '2',
          label: '已驳回'
        },
        {
          value: '3',
          label: '处理中'
        },
        {
          value: '4',
          label: '已取消'
        },
        {
          value: '5',
          label: '已完成'
        }
      ],
      dataForm: {
        page: 1,
        limit: 10,
        userAfterSalesCode: '',
        orderCode: '',
        goodsCode: '',
        goodsName: '',
        userAfterSalesStatusList: []
      },
      total: 0,
      dataList: []
    }
  },
  mounted () {
    this.getDataList(1)
  },
  methods: {
    getDataList () {
      this.getInquriyDataList(1)
    },
    // 获取列表数据
    getInquriyDataList (page = this.dataForm.page) {
      this.dataForm.page = page
      if (this.dataLoading) {
        return false
      }
      this.dataLoading = true
      let obj = {
        ...this.dataForm,
        userAfterSalesStatusList: this.dataForm.userAfterSalesStatusList.length ? this.dataForm.userAfterSalesStatusList : undefined,
        appCode: 'PLANTMATE_OFFICIAL',
        // 数据权限控制 1商城端 2webShop端 3发起收某订单全部售后数据
        queryDataPermissionsType: '1'
      }
      this.$http
        .post(`/front/consumer/userAfterSales/list`, obj)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.total = 0
            this.dataList = []
            return false
          }
          this.total = res.data.count || 0
          this.dataList = res.data.data || []
        })
        .catch(() => {
          this.dataList = []
          this.total = 0
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    // 更改分页条数
    pageSizeChangeHandle (val) {
      this.dataForm.limit = val
      this.getDataList(1)
    },
    // 查看详情
    detailHandle (row) {
      const srcInfo = this.$router.resolve({
        path: '/personalCenter/afterSalesDetail',
        query: {
          id: row.id
        }
      })
      window.open(srcInfo.href, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.inquiry_list {
  .title_row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .inquiry-tab-item {
    display: inline-block;
    margin-left: 10px;
    text-align: center;
    background: #ffffff;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    letter-spacing: 0;
    margin-right: 24px;
    cursor: pointer;
  }
  .tab-item-active {
    color: #1d65a8;
    border-bottom: 2px solid #1d65a8;
  }
  .tooltip-content {
    max-width: 500px;
    text-align: center;
    border-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .back_content {
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>
